const AssistantActionTypes = {
  SET_CREATE_APPOINTMENT: "ASSISTANT_SET_CREATE_APPOINTMENT",
  SAVE_CONTACT_DATA: "ASSISTANT_SAVE_CONTACT_DATA",
  LOADING_ASSISTANT:"LOADING_ASSISTANT",
  CLEAR_ASSISTANT:"CLEAR_ASSITANT",
  ADD_TOTAL_CONTACT_ITEM:"ADD_TOTAL_CONTACT_ITEM"
};

export default AssistantActionTypes;
